// Material Symbols (Rounded) — the Material 3 icon set. The font is loaded once
// in main.tsx (`material-symbols/rounded.css`); this renders a single glyph via
// its ligature name (e.g. name="description"). `fill` toggles the filled variant
// used for active nav destinations, matching M3.
type IconProps = {
  name: string;
  size?: number;
  fill?: boolean;
  weight?: number;
  className?: string;
};

export function Icon({ name, size = 24, fill = false, weight = 400, className = '' }: IconProps): JSX.Element {
  const opsz = Math.max(20, Math.min(48, size));
  return (
    <span
      aria-hidden
      translate="no"
      className={`material-symbols-rounded ${className}`}
      style={{
        fontSize: `${size}px`,
        lineHeight: 1,
        fontVariationSettings: `'FILL' ${fill ? 1 : 0}, 'wght' ${weight}, 'GRAD' 0, 'opsz' ${opsz}`,
      }}
    >
      {name}
    </span>
  );
}
